module.exports = __webpack_public_path__ + "assets/img/cb82c5dfc7e86c90d9ecc20bceaa0af8.png";